/**
 * Evalúa qué boletos de la selección reciben descuento efectivo del cupón activo.
 *
 * @param {Array} ticketsSelected - Array de boletos seleccionados del store
 * @param {Object} promotions - Objeto de promoción activa
 * @returns {Array} - Subconjunto de boletos con descuento efectivo > 0
 */
export function getTicketsWithDiscount(ticketsSelected, promotions) {
  if (!promotions || !ticketsSelected || ticketsSelected.length === 0) {
    return [];
  }

  const { valid_for_ticket_type_list, discount_type, discount_amount, bundle_rule } = promotions;

  if (!valid_for_ticket_type_list || !discount_type) {
    return [];
  }

  // Agrupar por ticket_type_id
  const groupedByType = {};
  ticketsSelected.forEach((ticket) => {
    const typeId = ticket.ticket_type_id;
    if (!groupedByType[typeId]) {
      groupedByType[typeId] = [];
    }
    groupedByType[typeId].push(ticket);
  });

  const ticketsWithDiscount = [];

  Object.keys(groupedByType).forEach((typeId) => {
    const typeIdNum = parseInt(typeId, 10);
    const tickets = groupedByType[typeId];

    // Verificar elegibilidad
    const isEligible = valid_for_ticket_type_list.includes(typeIdNum);
    if (!isEligible) {
      return;
    }

    // Calcular descuento según tipo
    if (discount_type === 'percentage') {
      // Porcentaje: incluir todos los boletos elegibles con descuento > 0
      tickets.forEach((ticket) => {
        const discountValue = (discount_amount / 100) * ticket.price;
        if (discountValue > 0) {
          ticketsWithDiscount.push(ticket);
        }
      });
    } else if (discount_type === 'flat') {
      // Monto fijo: incluir todos los boletos elegibles con descuento > 0
      tickets.forEach((ticket) => {
        if (discount_amount > 0) {
          ticketsWithDiscount.push(ticket);
        }
      });
    } else if (discount_type === 'bundle') {
      // Bundle (NxM): calcular cuántos boletos reciben descuento
      if (!bundle_rule) {
        return;
      }

      const [N, M] = bundle_rule.split('x').map((val) => parseInt(val, 10));
      if (!N || !M || N <= 0) {
        return;
      }

      const totalQuantity = tickets.reduce((sum, ticket) => sum + ticket.quantity, 0);
      const completeBundles = Math.floor(totalQuantity / N);
      const ticketsWithBundleDiscount = completeBundles * N;

      // Incluir solo los primeros ticketsWithBundleDiscount boletos
      let counted = 0;
      for (const ticket of tickets) {
        const toInclude = Math.min(ticket.quantity, ticketsWithBundleDiscount - counted);
        if (toInclude > 0) {
          // Agregar este ticket tantas veces como quantity con descuento tenga
          for (let i = 0; i < toInclude; i++) {
            ticketsWithDiscount.push(ticket);
          }
          counted += toInclude;
        }
        if (counted >= ticketsWithBundleDiscount) {
          break;
        }
      }
    }
  });

  return ticketsWithDiscount;
}
